import { coerceAcraStatus, isAcraActiveStatus } from '../../lib/acraRegistry';

type AcraStatusBadgeProps = {
  status: string;
  className?: string;
};

/** Shorten long ACRA entity statuses for tight mobile list rows. */
export function shortAcraStatusLabel(status: string): string {
  const trimmed = status.trim();
  if (!trimmed) return '';
  if (/^live\b/i.test(trimmed)) return 'Live';
  if (/deregister/i.test(trimmed)) return 'Dereg.';
  if (/struck/i.test(trimmed)) return 'Struck';
  if (/cancel/i.test(trimmed)) return 'Cancel';
  if (trimmed.length > 10) return `${trimmed.slice(0, 8)}…`;
  return trimmed;
}

export function AcraStatusBadge({ status, className = '' }: AcraStatusBadgeProps) {
  const trimmed = coerceAcraStatus(status);
  if (!trimmed) return null;
  const active = isAcraActiveStatus(trimmed);
  const short = shortAcraStatusLabel(trimmed);
  return (
    <span
      className={[
        'acra-status-badge',
        active ? 'acra-status-badge--active' : 'acra-status-badge--inactive',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      title={short === trimmed ? 'ACRA registry status (data.gov.sg)' : `${trimmed} (ACRA)`}
    >
      <span className="acra-status-badge__full">{trimmed}</span>
      <span className="acra-status-badge__short" aria-hidden>
        {short}
      </span>
    </span>
  );
}
